import ReactDOM from 'react-dom/client';
import ReportManager from './reportmanager';
import { BrowserRouter, Routes, Route } from "react-router-dom";

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(  
    <ReportManager />  
);
